import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
  output,
  OutputEmitterRef,
  ViewChild,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { MoneyPipe } from 'src/app/core/layout/common/money.pipe';
import { Subject, take, takeUntil } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import {
  PartCategory,
  PartModel,
  ThreedProject,
} from '../../services/project-controller/project-controller';
import { PartListControllerService } from '../../services/part-list-controller/part-list-controller.service';
import { ProjectControllerService } from '../../services/project-controller/project-controller.service';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { CartControllerService } from '../../services/cart-controller/cart-controller.service';
import { CurrencyConvertPipe } from '../../pipe/currency-convert.pipe';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';

@Component({
  selector: 'part-grid-list',
  imports: [
    CommonModule,
    MatTabsModule,
    MatGridListModule,
    MatButtonModule,
    MatIconModule,
    MoneyPipe,
    CurrencyConvertPipe,
  ],
  templateUrl: './part-grid-list.component.html',
  styleUrl: './part-grid-list.component.scss',
})
export class PartGridListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('domEl') domEl: ElementRef<HTMLDivElement> | undefined;

  public project: ThreedProject | undefined;
  public selectedCategoryIndex: InputSignal<number> = input(0);

  public selectedAddPart: OutputEmitterRef<PartModel> = output();
  public selectedAddCart: OutputEmitterRef<PartModel> = output();

  public isLoading: boolean = false;
  public isViewCompany: boolean = true;

  public cols: number = 3;
  public rowHeight: string = '3:1';
  public gutterSize: string = '8px';

  public environment = environment;

  private resizeObserver!: ResizeObserver;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    public threeGraphqlService: ThreeGraphqlService,
    private canvasController: CanvasControllerService,
    private projectController: ProjectControllerService,
    private partListController: PartListControllerService,
    private cart: CartControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.projectController.project$.pipe(takeUntil(this._unsubscribeAll)).subscribe((project) => {
      if (!project) return;
      this.project = project;
    });
  }

  ngAfterViewInit(): void {
    this.getResizeObserver();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this._unsubscribeAll.unsubscribe();
  }

  public onClickPart(part: PartModel): void {
    this.isLoading = true;
    const beforePart = this.partListController.categoryMap.get(part.category || part.uuid);
    if (beforePart == part) {
      this.canvasController.removeModel(part);
      this.partListController.removePart(part);
      this.canvasController.stateManager.removeModel(part);

      part.isSelected = false;
      this.isLoading = false;
      this.cd.markForCheck();
      return;
    }

    if (beforePart) {
      beforePart.isSelected = false;
      this.canvasController.removeModel(beforePart);
      this.partListController.removePart(beforePart);
    }
    this.canvasController.addModel(part).then(() => {
      part.isSelected = true;
      this.canvasController.stateManager.addModel(part);
      this.partListController.addPart(part);
      this.isLoading = false;
      this.cd.markForCheck();
    });
  }

  public includePart(part: PartModel): boolean {
    return this.partListController.categoryMap.has(part.category || part.uuid);
  }
  public onClickAddCart(part: PartModel): void {
    if (part.marketplaceProduct)
      this.cart.addCart(part.marketplaceProduct.channel, part.marketplaceProduct.variantId, 1);
    this.cd.markForCheck();
  }

  public onClickSoundBtn(sound: Howl): void {
    sound.stop();
    sound.play();
  }

  private getResizeObserver(): void {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width <= 599) {
          this.getGridListSetByBreakpoint(1, width, height);
        } else if (width >= 790 && width <= 959) {
          this.getGridListSetByBreakpoint(2, width, height);
        } else if (width >= 960 && width <= 1279) {
          this.getGridListSetByBreakpoint(3, width, height);
        } else if (width >= 1280 && width <= 1919) {
          this.getGridListSetByBreakpoint(3, width, height);
        } else if (width >= 1920) {
          this.getGridListSetByBreakpoint(3, width, height);
        }
      }
    });

    if (this.domEl) {
      this.resizeObserver.observe(this.domEl.nativeElement);
    }
  }

  private getGridListSetByBreakpoint(cols: number, width: number, height: number): void {
    this.cols = cols;
    this.rowHeight = this.getRowHeight(width / cols, height);
    this.gutterSize = '8px';
    this.cd.markForCheck();
  }

  private getRowHeight(width: number, height: number): string {
    if (width / height > 3) this.isViewCompany = false;
    else this.isViewCompany = true;
    this.cd.markForCheck();
    return `${width / height < 3 ? 3 : width / height}:${height / height}`;
  }
}
